/**
 * Reads a bundle's configuration from the JSON block `Frontend\ConfigBlock` prints beside its tag
 * (`<script type="application/json" id="<handle>-config">`) onto `window.AnudanEngine.config`, the one global
 * (`07-CODE-STANDARDS.md` §7.1). Since 0.9.37 the configuration is data, not an inline script, so an enforced Content
 * Security Policy does not block it. A page carrying two bundles (a donation form beside the portal) gets both blocks'
 * keys; a missing or unreadable block leaves the modules' same-origin defaults.
 *
 * @param {string} handle The script handle the block was printed for.
 * @return {void}
 */
export function readConfig( handle ) {
	const engine = ( window.AnudanEngine = window.AnudanEngine || {} );
	const block = document.getElementById( handle + '-config' );

	if ( ! block ) {
		return;
	}

	try {
		engine.config = Object.assign( engine.config || {}, JSON.parse( block.textContent || '{}' ) );
	} catch ( error ) {
		engine.config = engine.config || {};
	}
}
